<a *ngIf="!showLink()" >{{ status }}</a>
<a *ngIf="showLink()" href="{{ azureBatchLink }}" target="_blank">{{ status }}</a>
